export default new Promise(function (resolve) {
  var image = new Image();
  image.addEventListener('error', function () {
    return resolve(false);
  });
  image.addEventListener('load', function () {
    return resolve(image.width === 1);
  });
  image.src = 'data:image/webp;base64,UklGRiQAAABXRUJQVlA4IBgAAAAwAQCdASoBAAEAAwA0JaQAA3AA/vuUAAA=';
}).catch(function () {
  return false;
});